import script from "./ListTransferStudentTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTransferStudentTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./ListTransferStudentTableComponent.vue?vue&type=style&index=0&id=15b93b4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15b93b4f"]])

export default __exports__